import React, {Component} from 'react';
import {connect} from 'react-redux'
import VoucherDoc from './VoucherDoc'
class ReceiptVoucherDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:{doc:{},itemlist:[]}}
  }

  componentDidMount(){
    
  }

  componentWillMount() {
    // Instantiate a Realtime client 
  }

  loadNewDoc(callback) {
    this.refs.genDoc.getWrappedInstance().loadNewDoc((result)=>{
      if (callback!==undefined)
        callback(result.creditnote_no)
      
    },)
  }

  loadInvoiceStatusNewDoc(docNo) {
    this.refs.genDoc.getWrappedInstance().loadInvoiceStatusNewDoc(docNo)
  }

  loadInvoiceListStatusNewDoc(docNo) {
    this.refs.genDoc.getWrappedInstance().loadInvoiceListStatusNewDoc(docNo)
  }

  loadData(docNo) {
    this.refs.genDoc.getWrappedInstance().loadData(docNo)
  }

  renameDoc() {
    
  }

  onDocClose() {
    if (this.props.onClose!==undefined)
      this.props.onClose()
  }

  render() {
    return(
      <VoucherDoc
        ref={'genDoc'}
        title={this.props.title} 
        docType={this.props.docType}
        docSName={this.props.docSName}
        docName={this.props.docName}
        invoiceStatusDocType={this.props.invoiceStatusDocType}
        show={this.props.show}
        showDiscount={false}
        onLoadData={(data)=>{
          this.setState({data:data})
        }}
        onClose={this.onDocClose.bind(this)}
      />
    )
  }
}

export default ReceiptVoucherDoc = connect(
  (state) => ({messages: state.message.view.doc.DeliverySlipDoc}),null,null,{withRef:true}
)(ReceiptVoucherDoc);





// WEBPACK FOOTER //
// ./src/view/doc/ReceiptVoucherDoc.js